import { formatDreGroup } from "../../../components/Custom/CashFlow/Category/DreGroupFormat";

// Colunas do grid de categorias do fluxo de caixa.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true,
		// Sem largura o ag-grid usa 200px e corta nomes como "ADM ESCRITÓRIO - PESSOAL".
		// 350px cabe o maior nome cadastrado (40 caracteres) e segue a coluna Nome de Produtos.
		width: 350
	},
	{
		headerName: 'dre_group',
		field: 'dreGroup',
		// Mostra o nome do grupo, e não o código do enum (CUSTO_VARIAVEL).
		valueFormatter: (params) => formatDreGroup(params.value) || '-',
		// Sem filtro de texto na coluna: a busca é no servidor e compara com o código, então
		// quem digitasse o nome exibido ("Custo Variável") não acharia nada. O filtro por grupo
		// fica no seletor Grupo DRE do painel de filtros, que manda o valor exato.
		filter: false,
		width: 180
	},
	{
		headerName: 'description',
		field: 'description',
		filter: true,
		width: 300
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		width: 120
	}
]